// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBK2dwAMrNySUtvy793zVdzVKuvXNIotIw",
  authDomain: "humanway-c2a5e.firebaseapp.com",
  projectId: "humanway-c2a5e",
  storageBucket: "humanway-c2a5e.appspot.com",
  messagingSenderId: "841289247462",
  appId: "1:841289247462:web:17f09760a85c5500f0e927"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };
